/* =========================================================================
   AdiKt Gallery : garde anti-robots côté page
   Complète le contrôle hCaptcha de Shopify (Boutique en ligne > Préférences) :
   - champ piège invisible (un robot qui remplit tout le formulaire est écarté)
   - délai minimum entre le premier clic dans le formulaire et l'envoi
   - le visiteur doit avoir bougé / touché / tapé au clavier (pas un script nu)
   - refus des adresses Gmail « à points multiples » et des e-mails jetables
   S'applique à la newsletter (pied de page), au formulaire de la page Contact
   et à la fenêtre « Contacter la galerie » (qui appelle window.AGGuard.blocked).
   ========================================================================= */
(function () {
  'use strict';

  var human = false;
  function markHuman() { human = true; }
  ['pointerdown', 'mousemove', 'keydown', 'touchstart', 'wheel', 'scroll'].forEach(function (evt) {
    window.addEventListener(evt, markHuman, { once: true, passive: true });
  });

  var DISPOSABLE = /@(mailinator|yopmail|guerrillamail|10minutemail|tempmail|temp-mail|trashmail|sharklasers|getnada|maildrop|throwawaymail|fakeinbox|dispostable|mintemail|emailondeck|moakt|mohmal|tmpmail|spam4)\./i;

  function isFr() { return (document.documentElement.lang || 'fr').slice(0, 2) === 'fr'; }

  /* Les inscriptions abusives utilisent des variantes d'une même boîte Gmail avec beaucoup de points
     (ex. c.h.l.o.e.p.d.l.y…@gmail.com). Une vraie adresse en a rarement plus de deux. */
  function blockedEmail(email) {
    var v = String(email || '').trim().toLowerCase();
    if (!v) { return false; }
    var m = /^([^@]+)@(gmail\.com|googlemail\.com)$/.exec(v);
    if (m && (m[1].match(/\./g) || []).length >= 3) { return true; }
    return DISPOSABLE.test(v);
  }

  var MIN_MS = 1200;
  var MSG_EMAIL = {
    fr: 'Cette adresse e-mail n’est pas acceptée. Utilisez votre adresse principale ou écrivez-nous depuis la page Contact.',
    en: 'This email address is not accepted. Please use your main address or write to us from the Contact page.'
  };

  /* Utilisé par la fenêtre « Contacter la galerie » (assets via snippets/ag-contact.liquid) */
  window.AGGuard = {
    blocked: function (email, elapsedMs) {
      return blockedEmail(email) || !human || (typeof elapsedMs === 'number' && elapsedMs < 2500);
    }
  };

  function isGuardedForm(f) {
    if (!f || f.nodeName !== 'FORM' || f.id === 'ag-contact') { return false; }
    var a = f.getAttribute('action') || '';
    return a.indexOf('/contact') !== -1;
  }

  function prepare(f) {
    if (f.dataset.agGuard) { return; }
    f.dataset.agGuard = '1';
    var wrap = document.createElement('div');
    wrap.className = 'ag-hp';
    wrap.setAttribute('aria-hidden', 'true');
    var input = document.createElement('input');
    input.type = 'text';
    input.name = 'contact[ag_hp]';
    input.tabIndex = -1;
    input.autocomplete = 'off';
    input.setAttribute('autocomplete', 'off');
    wrap.appendChild(input);
    f.appendChild(wrap);
    f.addEventListener('focusin', function () {
      if (!f.dataset.agT0) { f.dataset.agT0 = String(Date.now()); }
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[action*="/contact"]');
    for (var i = 0; i < forms.length; i++) { if (isGuardedForm(forms[i])) { prepare(forms[i]); } }
  }

  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!isGuardedForm(f)) { return; }
    prepare(f);
    var hp = f.querySelector('.ag-hp input');
    var emailEl = f.querySelector('input[type="email"]');
    var email = emailEl ? emailEl.value : '';
    var t0 = parseInt(f.dataset.agT0 || '0', 10);
    var elapsed = t0 ? Date.now() - t0 : 0;

    /* 1) champ piège rempli : robot, on abandonne sans rien dire */
    if (hp && hp.value) { ev.preventDefault(); ev.stopImmediatePropagation(); return; }

    /* 2) adresse refusée : message clair pour un humain */
    if (blockedEmail(email)) {
      ev.preventDefault(); ev.stopImmediatePropagation();
      if (emailEl && emailEl.setCustomValidity) {
        emailEl.setCustomValidity(MSG_EMAIL[isFr() ? 'fr' : 'en']);
        emailEl.reportValidity();
        emailEl.addEventListener('input', function () { emailEl.setCustomValidity(''); }, { once: true });
      }
      return;
    }

    /* 3) aucune interaction humaine, ou formulaire jamais touché : robot */
    if (!human || !t0) { ev.preventDefault(); ev.stopImmediatePropagation(); return; }

    /* 4) envoi trop rapide : on patiente un instant puis on renvoie (cas d'un remplissage automatique rapide) */
    if (elapsed < MIN_MS) {
      ev.preventDefault(); ev.stopImmediatePropagation();
      setTimeout(function () {
        if (f.requestSubmit) { f.requestSubmit(); } else { f.submit(); }
      }, MIN_MS - elapsed + 50);
      return;
    }

    if (hp) { hp.removeAttribute('name'); }
  }, true);

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
